<template>
  <div>
    <!-- loading -->
    <div
      v-if="requestStatus == 'REQUEST_PENDING' "
      class="d-flex flex-row justify-content-between align-items-center"
    >
      <div class="d-flex flex-row align-items-start">
        <b-spinner class="mx-2" variant="primary"></b-spinner>
        <p class="h5 mr-1 my-0">{{partNumber}}</p>
      </div>
      <div class="d-flex flex-row justify-content-end align-items-center">
        <div class="d-flex flex-column w-50 mx-2">
          <b-form-input
            class
            size="sm"
            id="partsQuantity"
            type="number"
            placeholder="Qty.."
            v-model="quantity"
            disabled
          ></b-form-input>
        </div>
      </div>
    </div>

    <!-- loaded success -->
    <div
      v-if="requestStatus === 'REQUEST_SUCCESS'"
      class="d-flex flex-row justify-content-between align-items-center"
    >
      <div class="d-flex flex-column align-items-start">
        <p class="h5 mr-1 my-0">{{partNumber}}</p>
        <p class="text-secondary font-weight-light mr-1">{{description}}</p>
        <div class="d-flex flex-row align-items-start mt-1 mb-0 p-0">
          <p class="text-danger mb-0">{{`$${dealerprice.toFixed(2)}`}}</p>
          <p class="mx-3 mb-0">{{`+${stock || 0} in stock`}}</p>
        </div>
        <div class="d-flex flex-row align-items-start mt-1 mb-0 p-0">
          <p class="font-weight-light font-italic mb-0">{{`retail: $${retailprice}`}}</p>
        </div>
      </div>
      <div class="d-flex flex-row justify-content-end align-items-center">
        <div class="d-flex flex-column w-50 mx-2">
          <b-form-input
            :state="quantity > stock ? false : null"
            size="sm"
            id="partsQuantity"
            type="number"
            placeholder="Qty.."
            aria-describedby="input-live-feedback"
            v-model="quantity"
          ></b-form-input>
          <b-form-invalid-feedback
            id="input-live-feedback"
          >exceeds stock, parts will need to be ordered..</b-form-invalid-feedback>
          <p
            class="p-0 m-0 font-weight-light text-nowrap"
          >{{`Subtotal: $${(dealerprice * quantity).toFixed(2)}`}}</p>
        </div>
        <div style="cursor:pointer">
          <i class="material-icons mx-2" @click="deleteItem">clear</i>
        </div>
      </div>
    </div>

    <!-- loaded invalid -->
    <div
      v-if="requestStatus === 'REQUEST_INVALID'"
      class="d-flex flex-row justify-content-between align-items-center"
    >
      <p class="h6 mr-1 my-0 text-danger">{{`${partNumber} is not a valid part number...`}}</p>
      <div style="cursor:pointer">
        <i class="material-icons mx-2" @click="deleteItem">clear</i>
      </div>
    </div>

    <!-- loading failed -->
    <div
      v-if="requestStatus === 'REQUEST_FAILED'"
      class="d-flex flex-row justify-content-between align-items-center"
    >
      <p class="h6 mr-1 my-0 text-danger">{{`Error adding ${partNumber}.. Please try again..`}}</p>
      <div style="cursor:pointer">
        <i class="material-icons mx-2" @click="deleteItem">clear</i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "order-item",
  props: {
    partNumber: String
  },
  data() {
    return {
      subtotal: 0,
      quantityInput: 0
    };
  },
  methods: {
    deleteItem() {
      this.$store.commit("order/removeItem", { partNumber: this.partNumber });
    }
  },

  computed: {
    description: {
      get() {
        return this.$store.getters["order/itemDetails"](this.partNumber)
          .description;
      }
    },
    dealerprice: {
      get() {
        return this.$store.getters["order/itemDetails"](this.partNumber)
          .dealer_price;
      }
    },
    retailprice: {
      get() {
        return this.$store.getters["order/itemDetails"](this.partNumber)
          .retail_price;
      }
    },
    stock: {
      get() {
        return this.$store.getters["order/itemDetails"](this.partNumber).stock;
      }
    },

    quantity: {
      get() {
        return this.$store.getters["order/itemDetails"](this.partNumber)
          .orderQuantity;
      },
      set(val) {
        this.$store.commit("order/updateItemQuantity", {
          partNumber: this.partNumber,
          orderQuantity: val
        });
      }
    },
    requestStatus() {
      return this.$store.getters["order/itemDetails"](this.partNumber).status;
    }
  }
};
</script>

